/* eslint-disable no-undef */
import React, { useState } from "react";
import { PluginIntro } from "./sections/PluginIntro";
import { CreateBoardCTA } from "./sections/CreateBoardCTA";
import { GetBoardInfo } from "./sections/GetBoardInfo";
import { CustomizeBoard } from "./sections/CustomizeBoard";

// Below classes must be available dynamically.
// bg-plugin-1 bg-plugin-2 bg-plugin-3 placeholder-plugin-1 placeholder-plugin-2 placeholder-plugin-3 border-plugin-1 border-plugin-2 border-plugin-3"

function App() {
	const [boardInfo, setBoardInfo] = useState();
	const [savedConfig, setSavedConfig] = useState(hbConfig);

	return (
		<div className="bg-white mt-5 flex justify-center rounded-md overflow-hidden p-8 text-base">
			<div className="max-w-xl">
				<PluginIntro />
				{!savedConfig && <CreateBoardCTA />}
				<GetBoardInfo onData={setBoardInfo} savedConfig={savedConfig} />
				{/* Once the board data is available, we have to hand over to the customize section. */}
				{/* But if there is already embed config available, we can show that as well. */}
				<CustomizeBoard
					data={boardInfo}
					savedConfig={savedConfig}
					onDelete={() => {
						setSavedConfig();
						setBoardInfo();
					}}
				/>
			</div>
		</div>
	);
}
export default App;
